import { ReactElement } from 'react';

import { PollFormValues, PostDraft } from 'types';

import { PollForm } from '../PollForm';
import { useCreatePollForm } from './hooks';

interface CreatePollFormProps {
  draft: PostDraft | null;
  defaultValues: (draft?: PostDraft) => PollFormValues;
  onClose?: () => void;
}

export function CreatePollForm({
  draft,
  defaultValues,
  onClose,
}: CreatePollFormProps): ReactElement {
  const { handleSubmit, isLoading } = useCreatePollForm({ draft, onClose });

  return (
    <PollForm
      draft={draft}
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
}
